import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalHeader: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.modal-header',
		defaultMessage: 'Add a new status',
		description: 'Title of the modal',
	},
	statusNameLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-label',
		defaultMessage: 'Status name',
		description: 'Label for the status name input',
	},
	statusNamePlaceholder: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-placeholder',
		defaultMessage: 'Enter status name',
		description: 'Placeholder for the status name input',
	},
	statusNameAlreadyExistsError: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-already-exists-error',
		defaultMessage: 'A status with that name already exists, please enter a different name.',
		description: 'Error message when the status name already exists',
	},
	statusNameBlankErrorNonFinal: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-blank-error-non-final',
		defaultMessage: 'Status name cannot blank, please enter a different name.',
		description: 'Error message when the status name already exists',
	},
	statusCategoryLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-category-label',
		defaultMessage: 'Status category',
		description: 'Label for the status category input',
	},
	statusCategoryHelper: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-category-helper',
		defaultMessage: 'Categories group multiple statuses of the same kind.',
		description: 'Helper text for the status category',
	},
	cancelButton: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button text for Cancel',
	},
	addButton: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.add-button',
		defaultMessage: 'Add',
		description: 'Button text for adding a new status',
	},
	newStatusInfoMessage: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.new-status-info-message',
		defaultMessage: 'This status will be added to all the Lists in this project.',
		description: 'Information displayed on the modal when adding a new status',
	},
});
